import { WebPlugin } from '@capacitor/core';
export class NotificationReaderWeb extends WebPlugin {
    async getActiveNotifications() {
        throw this.unimplemented('Not implemented on web.');
    }
    async openAccessSettings() {
        throw this.unimplemented('Not implemented on web.');
    }
    async isAccessEnabled() {
        throw this.unimplemented('Not implemented on web.');
    }
    async getNotifications(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async deleteAllNotifications() {
        throw this.unimplemented('Not implemented on web.');
    }
    async importNotifications(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async getTotalCount() {
        throw this.unimplemented('Not implemented on web.');
    }
    async getInstalledApps() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map